import {
  FULL_DATE_FORMAT,
  REQUIRED_FIELD,
  SERVER_DATE_FORMAT,
} from "@/lib/constants";
import validations from "@/utils/validations";
import { Input } from "@chakra-ui/react";
import { InputMask } from "@react-input/mask";
import moment from "moment";

const DateOfBirthInput = ({
  register,
  fieldName = "DateOfBirth",
}: {
  register: Function;
  fieldName?: string;
}) => {
  return (
    <Input
      placeholder="12/13/1991"
      as={InputMask}
      mask="__/__/____"
      replacement={{ _: /\d/ }}
      type="text"
      {...register(fieldName, {
        required: REQUIRED_FIELD,
        validate: validations.dateOfBirth,
        setValueAs: (value: string) =>
          moment(value, FULL_DATE_FORMAT).format(SERVER_DATE_FORMAT),
      })}
    />
  );
};

export default DateOfBirthInput;
